import { VALID_VAT_NO_REGEX } from '@funnellab/shared/src/utils/regexCollection';
import type { ValidationFunctionWithParams, ValidationRule } from '../types';

export const validVatNoFn = (
  subdivision_code: string,
): ValidationFunctionWithParams<string, { subdivision_code: string }> => {
  return (value) => {
    return {
      isValid:
        !value ||
        !VALID_VAT_NO_REGEX[subdivision_code] ||
        VALID_VAT_NO_REGEX[subdivision_code][0].test(value),
      params: { subdivision_code },
    };
  };
};
export const validVatNo = (
  subdivision_code: string,
): ValidationRule<string, { valid_vat_no: string | undefined }> => {
  const valid_vat_no = VALID_VAT_NO_REGEX[subdivision_code]?.[1];
  return {
    fn: validVatNoFn(subdivision_code),
    messageKey: 'invalidVatNo',
    messageParams: { valid_vat_no },
  };
};
